module.exports = __webpack_public_path__ + "media/images/excel-a038c599a33b3a04df137678c0151ee9.svg";